// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"ba8aa5b7","212":"7bb55891","542":"4b0f9f7a","698":"da071670","741":"94cdce61","835":"fda16962","924":"738827d9","960":"36d73d9b","971":"e2df29aa"}[chunkId] + ".chunk.css";
};